module.exports = __webpack_public_path__ + "img/like_fill.4928d508.svg";